import { useSelector } from "react-redux";
import { useSEO } from "../../hooks/useSEO";
import { HOME_ROUTE } from "../../routes/constant";
import HeroSlider from "../../components/home/hero/HeroSlider";
import CategoryGrid from "../../components/home/category/CategoryGrid";
import PromotionBanner from "../../components/home/promotion/PromotionBanner";
import ProductCarousel from "../../components/home/products/ProductCarousel";
import HowItWorks from "../../components/home/how-works/HowItWorks";
import WhyTap2Cash from "../../components/home/why-us/WhyTap2Cash";
import SellSection from "../../components/home/sell-info/SellSection";
import { useTheme } from "../../theme/ThemeProvider";
import Feedback from "../../components/home/feedback/Feedback";
import Layout from "../../components/Layout";
import RectangleGridButtons from "../../components/home/nav/NavButton";
import DownloadApp from "../../components/common/DownloadApp"; // <-- add

const Home = () => {
  const {
    categories,
    popularProducts,
    smartPhones,
    reviews,
    tablets,
    smartWatches,
    laptops,
    sliders,
    promotionBanners,
    heroBanners,
    loading,
    error,
  } = useSelector((state) => state.home);
  const { isDarkMode } = useTheme();

  // Apply SEO only when data is loaded
  const hasData = !loading && !error && categories.length > 0;

  useSEO(HOME_ROUTE, hasData ? {
    hasData: true,
    categoriesCount: categories.length,
    productsCount: popularProducts.length,
  } : null);

  // Don't render content if still loading or has error
  if (loading && !hasData) {
    return null; // GlobalLoaderCompact will handle loading
  }

  return (
    <Layout>
      <div className="mx-auto overflow-x-hidden max-w-7xl">
        <RectangleGridButtons isDarkMode={isDarkMode} />

        <div className="mt-6">
          <HeroSlider
            sliders={sliders}
            heroes={heroBanners}
            isDarkMode={isDarkMode}
          />
        </div>

        <CategoryGrid categories={categories} isDarkMode={isDarkMode} />

        <div className="pb-3 md:pb-5">
          <Feedback isDarkMode={isDarkMode} reviews={reviews || []} />
        </div>

        <PromotionBanner
          promotions={promotionBanners}
          isDarkMode={isDarkMode}
        />

        {popularProducts && popularProducts.length > 0 && (
          <ProductCarousel
            title="Popular Products"
            products={popularProducts}
            isDarkMode={isDarkMode}
          />
        )}

        {smartPhones && smartPhones.length > 0 && (
          <ProductCarousel
            title="Best Selling Smartphones"
            products={smartPhones}
            isDarkMode={isDarkMode}
          />
        )}

        {tablets && tablets.length > 0 && (
          <ProductCarousel
            title="Popular Tablets"
            products={tablets}
            isDarkMode={isDarkMode}
          />
        )}

        {smartWatches && smartWatches.length > 0 && (
          <ProductCarousel
            title="Smart Watches"
            products={smartWatches}
            isDarkMode={isDarkMode}
          />
        )}

        {laptops && laptops.length > 0 && (
          <ProductCarousel
            title="Laptops"
            products={laptops}
            isDarkMode={isDarkMode}
          />
        )}

        <HowItWorks isDarkMode={isDarkMode} />
        <WhyTap2Cash isDarkMode={isDarkMode} />

        {/* App Download CTA — placed before final SellSection */}
        <div className="px-6 py-6 mb-5">
          <DownloadApp isDarkMode={isDarkMode} variant="compact" />
        </div>

        <SellSection isDarkMode={isDarkMode} />
      </div>
    </Layout>
  );
};

export default Home;